var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBadsmile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3121_68868)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 24C9.86883 24 0 33.8688 0 46C0 58.1312 9.86883 68 22 68C34.1312 68 44 58.1312 44 46C44 33.8688 34.1312 24 22 24ZM11 50.5833C10.2502 50.5833 9.54433 50.1195 9.27667 49.3715C8.932 48.4182 9.427 47.3695 10.3803 47.0267L17.7137 44.383C18.6633 44.0365 19.7175 44.5315 20.0585 45.4867C20.4032 46.44 19.9082 47.4887 18.9548 47.8315L11.6215 50.4752C11.418 50.5503 11.2053 50.5852 11 50.5852V50.5833ZM28.9703 58.0963C28.611 58.5803 28.0592 58.8333 27.4982 58.8333C27.1187 58.8333 26.7337 58.716 26.4037 58.4703C26.3908 58.4612 24.3632 57 22 57C19.6368 57 17.6073 58.4612 17.589 58.4758C16.7695 59.0698 15.6237 58.8957 15.0297 58.0853C14.4302 57.275 14.597 56.1328 15.4055 55.5297C15.5265 55.4398 18.3975 53.3333 22.0018 53.3333C25.6062 53.3333 28.4753 55.4398 28.5982 55.5297C29.4085 56.1347 29.5772 57.2823 28.9722 58.0945L28.9703 58.0963ZM34.7252 49.3715C34.4575 50.1195 33.7517 50.5833 33.0018 50.5833C32.7965 50.5833 32.5838 50.5485 32.3803 50.4733L25.047 47.8297C24.0937 47.485 23.6005 46.4363 23.9433 45.4848C24.2862 44.5297 25.3422 44.0347 26.2882 44.3812L33.6215 47.0248C34.5748 47.3695 35.068 48.42 34.7252 49.3715Z",
    fill: "#5196FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3121_68868"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white",
    transform: "translate(0 24)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadsmile);
export default __webpack_public_path__ + "static/media/badsmile.11309c2ab6e2ebfc95b4881905768bbb.svg";
export { ForwardRef as ReactComponent };